import script from "./CreateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateModal.vue?vue&type=script&setup=true&lang=ts"

import "./CreateModal.vue?vue&type=style&index=0&id=e1e7979e&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1e7979e"]])

export default __exports__